import { useQuery } from "@tanstack/react-query";
import { prepareParams } from "../actions/Layers/actions";
import { LayerFilter } from "../actions/Layers/constants";
import { format2Frontend } from "../actions/Layers/util";
import { getFilledArrayOrDefault } from "../utils";
import { callAvosApi } from "../utils/useAvosApiHook";

export const layerListQueryKey = (tenantId?: string) => ["layers", tenantId];

// The overview list. A null filter keeps the query disabled, which is how the
// overview clears the table while a new tab/page is being composed.
export function useLayerList(tenantId: string | undefined, filter: LayerFilter | null) {
    const params = filter ? prepareParams(filter) : null;

    return useQuery({
        queryKey: [...layerListQueryKey(tenantId), params],
        queryFn: async () => {
            const response = await callAvosApi(`/${tenantId}/layers/`, { params });
            const data = response.data ?? {};
            return { ...data, results: getFilledArrayOrDefault(data.results).map(format2Frontend) };
        },
        enabled: !!tenantId && !!params,
        // The overview query is expensive, so serve it from cache for a short
        // while instead of refetching on every window focus or tab revisit.
        staleTime: 30_000,
    });
}
